import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=54da0f60&scoped=true&"
import script from "./ReadMore.vue?vue&type=script&lang=ts&"
export * from "./ReadMore.vue?vue&type=script&lang=ts&"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=54da0f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da0f60",
  null
  
)

export default component.exports